<template>
	<el-tabs type="border-card" class="h-100 no-scroll">
		<el-tab-pane class="mt-2" v-for="(menu, index) in tabMenuList" :key="index" :label="menu.name">
			<component
				:is="menu.tag"
				class="px-3 pb-2"
				:scrId="scrId"
				@OpenGridOpPopup="OpenGridOpPopup"
				@PopupOpen="PopupOpen"
				:sendParam="sendParam"
				:tab="tab"
				:causPartNo="partNo"
			></component>
		</el-tab-pane>

		<!--OP코드 팝업-->
		<op-cd-popup ref="opCdPopup" @SendData="sendData" @Refresh="Refresh" :scrId="scrId" />

		<!-- 엑셀업로드-->
		<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
	</el-tabs>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import CmpnOpPmcList from '../Tab/PMCNo/CmpnOpPmcList.vue';
import CmpnOpTableTab from '../Tab/OPCode/CmpnOpTableTab.vue';
import OpCdPopup from '../Popup/OpCdPopup.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창

export default {
	props: {
		scrId: { type: String, default: '' },
		tab: { type: String, default: '' }
	},
	data() {
		return {
			tabMenuList: [
				{ tag: 'cmpn-op-table-tab', name: 'OP Code' },
				{ tag: 'cmpn-op-pmc-list', name: this.tab }
			],
			sendParam: {} //op코드 팝업
		};
	},
	components: { CmpnOpPmcList, CmpnOpTableTab, OpCdPopup, ExcelUploadModal },
	computed: {
		...rootComputed,
		...serviceComputed,
		partNo() {
			const partNo = this.cmpnMstPopup.causPartNo;
			return partNo;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			const cmpnNo = this.cmpnMstPopup.cmpnNo;
			this.getCmpnMstPopList_(cmpnNo);
		},
		OpenGridOpPopup(commCd) {
			this.$refs.opCdPopup.open(commCd); //.open(param);
		},
		sendData(param) {
			this.sendParam = param; //watch감시용
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	}
};
</script>
